import React from 'react';
import { ChevronsUp, ChevronsDown } from 'lucide-react';

const ContextMenu = ({ x, y, show, onClose, onBringToFront, onSendToBack }) => {
    if (!show) {
        return null;
    }

    return (
        <div 
            className="fixed z-[100] bg-white dark:bg-gray-800 shadow-lg rounded-lg border border-gray-200 dark:border-gray-700 p-1"
            style={{ top: y, left: x }}
            onClick={onClose}
        >
            <ul className="space-y-1">
                <li>
                    <button 
                        onClick={onBringToFront}
                        className="w-full flex items-center gap-3 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
                    >
                        <ChevronsUp className="h-4 w-4" />
                        <span>Bring to Front</span>
                    </button>
                </li>
                <li>
                    <button 
                        onClick={onSendToBack}
                        className="w-full flex items-center gap-3 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
                    >
                        <ChevronsDown className="h-4 w-4" />
                        <span>Send to Back</span>
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default ContextMenu;
